module.exports = __webpack_public_path__ + "static/media/edison-174.f71604ad.jpg";